import { takeEvery } from 'redux-saga';
import { call, put, fork, select } from 'redux-saga/effects';

import { addedToRegistry, setRegistries } from '../actions/registryActions';
import { showCannotAddToListError } from '../../../product/js/actions/productActions';
import ENUMS from '../enums/registryEnums';
import { LOGIN_FINISHED } from '../../../core/js/actions/userActions';

import {
    init as productCreateRegistryModalInit
} from '../../../product/js/components/productCreateRegistryModalComponent';

import { handleUserLogin } from '../../../core/js/sagas/loginSagas';
import { makeRequest } from '../../../core/js/sagas/makeRequest';

import { resetAddToRegistry } from '../../../product/js/actions/productRegistryActions';
import { getAddToRegistryEntity } from '../routes/registryEntities';
import {
    getAddToRegistryRoute,
    getRegistriesRoute
} from '../routes/registryRoutes';

import { error } from '../../../core/js/utils/logger';
import { delay as delayMS } from '../../../core/js/utils';
import { launchModal } from '../../../core/js/utils/modalUtils';
import { isQuickshop } from '../../../product/js/utils/quickshopUtils';
import {
    getAddedToRegistryMessaging,
    getProductAddToRegistryAction,
    replaceRegistry
} from '../utils/registryUtils';

import { config } from '../../../product/js/configs/config';

import { getProductForAction } from '@product/js/utils/utils';
import { handleUtagEvent } from '@core/js/actions/initialActions';
import { createGAEvent } from '@core/js/utils/analyticsUtils';

export function* addToRegistrySaga() {
    yield* takeEvery(ENUMS.ADD_TO_REGISTRY, handleAddtoRegistrySaga);
}

export function* checkProductRegistriesSaga() {
    yield* takeEvery(ENUMS.CHECK_PRODUCT_REGISTRIES, handleCheckProductRegistriesSaga);
}

export function* getRegistriesSaga() {
    yield* takeEvery(ENUMS.GET_REGISTRIES, handleGetRegistriesSaga);
}

export function* getUserLoggedInSaga() {
    yield* takeEvery(LOGIN_FINISHED, handleUserLoggedInSaga);
}

export function* promptRegistryCreateSaga() {
    yield* takeEvery(ENUMS.PROMPT_REGISTRY_CREATE, handlePromptRegistryCreateSaga);
}

export function* handleAddtoRegistrySaga(action) {
    let state = yield select();

    try {
        const entity = getAddToRegistryEntity(state, action);
        const route = getAddToRegistryRoute(state, entity);
        const res = yield call(makeRequest, route);
        const payload = {
            messages: getAddedToRegistryMessaging(state, res.registry),
            registries: replaceRegistry(state, res.registry)
        };
        yield put(addedToRegistry(payload, action.meta));
        yield fork(resetAddToRegistrySaga, config.addToCart.resetDelay, action.meta.component);

        const product = getProductForAction(state, action);
        const gaEvent = createGAEvent(
            _.get(state, 'core.pageType', 'pdp'),
            'add to registry success',
            _.get(product, 'product.displayName')
        );
        yield put(handleUtagEvent(gaEvent, 'link'));
    } catch (err) {
        error('Add to Registry Error', err);
        yield put(showCannotAddToListError(isQuickshop(state), action.meta.component, err.entity.code));
        yield put(resetAddToRegistry(action.meta.component));
    }
}

export function* handleCheckProductRegistriesSaga({ meta }) {
    const loginState = yield call(handleGetRegistriesSaga);

    if (loginState.canceled) {
        return loginState;
    }
    let state = yield select();
    const { type, payload } = getProductAddToRegistryAction(state, { meta });
    yield put(type(payload, meta));

    return {};
}

export function* handleGetRegistriesSaga() {
    const loginState = yield call(handleUserLogin, 'get-registries');

    if (loginState.canceled) {
        return loginState;
    }

    let state = yield select();
    const route = getRegistriesRoute(state);
    const payload = yield call(makeRequest, route);

    yield put(setRegistries(payload));

    return {};
}

export function* handlePromptRegistryCreateSaga({ meta }) {
    launchModal(
        productCreateRegistryModalInit,
        {},
        meta.e,
        meta.component.name
    );
}

export function* handleUserLoggedInSaga() {
    let state = yield select();
    _.delay(() => {
        $(document).trigger('user:login', { profile: state.core.profile });
    });
}

export function* resetAddToRegistrySaga(ms, component) {
    yield call(delayMS, ms);
    yield put(resetAddToRegistry(component));
}

export default [
    addToRegistrySaga,
    checkProductRegistriesSaga,
    getRegistriesSaga,
    getUserLoggedInSaga,
    promptRegistryCreateSaga
];
